import { CloseOutlined } from "@ant-design/icons";
import { Button } from "components/Button";
import { BTN_SIZE, BTN_VARIANTS } from "constants/components";
import useAuth from "hooks/useAuth";
import React, { useEffect, useRef } from "react";

import { routes } from "@/constants/routes";
import { Typography } from "components/Typography";
import { CONTENT } from "constants/dataLayer";
import { pushToDataLayer } from "core/utils/utils.helper";
import { pushAppsFlyerGtmEvent } from "core/utils/appsflyer-gtm.helper";
import { useNavigate } from "react-router-dom";
import { APPSFLYER_EVENTS } from "@/constants/appsflyer";
import styles from "./AuthModal.module.scss";
export interface AuthModalProps {
  isFullPage?: boolean;
  isSticky?: boolean;
  closable?: boolean;
  closeModal?: () => void;
}
export const AuthModal: React.FC<AuthModalProps> = (props: any) => {
  const { isFullPage, isSticky, closable, closeModal } = props;
  const auth: any = useAuth();
  const navigate = useNavigate();
  const isLoggedIn = auth?.isAuthenticated ?? false;
  const gateViewedTracked = useRef<boolean>(false);

  useEffect(() => {
    if (!gateViewedTracked.current) {
      pushAppsFlyerGtmEvent(APPSFLYER_EVENTS.REGISTRATION_GATE_VIEWED, {
        timestamp: Date.now(),
      });
      gateViewedTracked.current = true;
    }
  }, []);

  return (
    <div
      className={`${styles.overlay} ${isFullPage ? styles.full_height : ""} ${isSticky && styles.flex_start}`}
    >
      <div
        className={`${styles.modal} ${isSticky && styles.modal__sticky_container}`}
        tabIndex={0}
        role="dialog"
        aria-modal="true"
        aria-label="Authentication Modal popup"
      >
        {closable && (
          <Button
            className={styles.close_icon}
            onClick={() => closeModal()}
            type={BTN_VARIANTS.NEUTRAL}
            size={BTN_SIZE.NEUTRAL}
          >
            <CloseOutlined />
          </Button>
        )}

        <div className={styles.section_content_heading}>
          <Typography variant="h3" title="Sign up for free!">
            Sign up for free!
          </Typography>
        </div>
        <div className={styles.section_content_subheading}>
          <Typography
            variant="p"
            title="Sign up now to start tracking your menopause journey and gain exclusive access to Karen Heras-Kelly’s “M-Powerment” Program. "
          >
            Sign up now to start tracking your menopause journey and gain
            exclusive access to Karen Heras-Kelly’s “M-Powerment” Program. 
          </Typography>
        </div>
        <div className={styles.section_content_buttons}>
          <Button
            size={BTN_SIZE.LARGE}
            type={BTN_VARIANTS.PRIMARY}
            onClick={() => {
              closeModal?.();
              navigate(routes.signup.path);
              pushToDataLayer({
                ...CONTENT.WELCOME.LOGIN,
                user_status: isLoggedIn,
              });
            }}
            className={styles.btn_red}
          >
            Sign up now
          </Button>
          <Button
            size={BTN_SIZE.LARGE}
            type={BTN_VARIANTS.LINK}
            onClick={() => {
              closeModal?.();
              navigate(routes.login.path);
              pushToDataLayer({
                ...CONTENT.WELCOME.LOGIN,
                user_status: isLoggedIn,
              });
            }}
            className={styles.btn_neutral}
          >
            Already have an account? Login
          </Button>
        </div>
      </div>
    </div>
  );
};
